import { Component, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core'; // Добавлен Renderer2
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router'; // Добавлен NavigationStart
import { MessageService } from 'primeng/api';
import { filter } from 'rxjs/operators';
import { UserContextService } from './shared/services/user-context.service';
import { AppSettings } from './shared/models/appsettings';
import { PrimeNG } from 'primeng/config';
import { AsyncPipe } from '@angular/common';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { NotificationsComponent } from './shared/components/notifications/notifications.component';
import { CookieConsentComponent } from './shared/components/cookie-consent/cookie-consent.component';
import { LoaderInfoComponent } from './shared/components/loader-info.component';
import { Page403Component } from './info/page403.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService],
  imports: [
    RouterOutlet,
    AsyncPipe,
    NavbarComponent,
    NotificationsComponent,
    CookieConsentComponent,
    LoaderInfoComponent,
    Page403Component,
  ],
})
export class AppComponent implements OnInit {
  title = 'Чемпионат идей';
  public sidebarEnable: boolean = true;
  loading$ = this.userContextSvc.isLoading$;

  constructor(
    protected userContextSvc: UserContextService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private primeNGConfig: PrimeNG,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(
        filter(
          (event) => event instanceof NavigationEnd || event instanceof NavigationStart
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.cleanupBlockedUI();
        }

        if (event instanceof NavigationEnd) {
          this.updatePageMeta();
        }
      });

    this.configurePrimeNG();
  }

  // В PrimeNg 21 сломан block-ui при редиректах, поэтому добавлен этот код, который убирает block-ui со старых страниц
  private cleanupBlockedUI() {
    try {
      this.renderer.removeClass(document.body, 'p-overflow-hidden');

      const blockers = document.querySelectorAll('.p-blockui, .p-blockui-document');
      blockers.forEach((el) => {
        if (el.parentNode) {
          this.renderer.removeChild(el.parentNode, el);
        }
      });
    } catch (e) {
      console.warn('BlockUI cleanup failed', e);
    }
  }

  private updatePageMeta() {
    let result = {
      title: this.title,
      sidebar: true,
    };
    let child = this.activatedRoute.firstChild;

    while (child) {
      if (!child.firstChild) {
        let data = child.snapshot.data || {};
        result.title = data['title'] || this.title;
        result.sidebar = data['sidebar'] !== false;
        break;
      }
      child = child.firstChild;
    }

    this.titleService.setTitle(result.title);
    this.sidebarEnable = result.sidebar;
  }

  private configurePrimeNG() {
    this.primeNGConfig.overlayOptions = {
      appendTo: 'body',
    };
    this.primeNGConfig.setTranslation({
      monthNames: AppSettings.datePickerConfig.monthNames,
      monthNamesShort: AppSettings.datePickerConfig.monthNamesShort,
      dayNamesMin: AppSettings.datePickerConfig.dayNamesMin,
      dayNamesShort: AppSettings.datePickerConfig.dayNamesShort,
      dayNames: AppSettings.datePickerConfig.dayNames,
      firstDayOfWeek: 1,
      today: 'Сегодня',
      clear: 'Очистить',
      dateFormat: 'dd/mm/yy',
      selectionMessage: '{0} эл. выбрано',
    });
  }
}
